import { useEffect, useState } from "react";

import DuiProgram from "../components/DUI-Program";
import DuiDetails from "../components/DuiDetails";
import PageLoading from "../components/PageLoading";

import * as API from "../api/api.js";

const LayoutOne = ({ slug }) => {
  const [loading, setLoading] = useState(false);
  const [duiInformation, setDuiInformation] = useState(null);
  const [duiDetail, setDuiDetail] = useState(null);
  const [duiImage, setDuiImage] = useState(null);
  // const small = require("../../src/assets/images/logo-small.png");

  useEffect(() => {
    setAdvancedDatas();
  }, [slug]);

  const setAdvancedDatas = () => {
    setLoading(true);
    API.getDatas(`/page?slug=${slug}`)
      .then((res) => {
        setDuiInformation(res.data.lessons);
        setDuiImage(res.data.banner_image_url);
        setDuiDetail(res.data.content);
        setLoading(false);
        document.title = `Metro Traffic School - ${res.data.name}`;
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      {loading && (
        <section
          style={{
            height: "auto",
          }}
          className="inner-page-dui  d-flex align-items-center justify-content-center"
        >
          <div className="container">
            <div className="row position-relative dui-school-blog">
              <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6 col-xl-6 mx-auto">
                <PageLoading
                  color={"var(--metro-yellow)"}
                  classes={"justify-content-center"}
                />
              </div>
            </div>
          </div>
        </section>
      )}
      {!loading && duiInformation && duiInformation.length && (
        <section
          style={{
            background: `url(${duiImage}) no-repeat top center `,
            height: "auto",
          }}
          className="inner-page-dui  d-flex align-items-center justify-content-center"
        >
          <div className="overlay"></div>
          <div className="container">
            <div className="row position-relative dui-school-blog">
              <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-6 col-xl-6 mx-auto">
                <div className="top-course-blog ">
                  <h5 className="course-detail-heading text-capitalize mb-md-3 mb-2">
                    {duiInformation[0].name}
                  </h5>
                  <p>{duiInformation[0].short_description}</p>
                  <div className="price-detail d-flex align-items-center justify-content-center  justify-content-sm-start flex-wrap flex-sm-nowrap mb-3 mb-4">
                    <div className="detail-btn">
                      {duiInformation[0].register_url && (
                        <a
                          href={duiInformation[0].register_url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn yellow-btn  d-flex align-items-center justify-content-center mb-4 mb-sm-0"
                        >
                          Get Started
                          <i className="fa-solid fa-circle-chevron-right"></i>
                        </a>
                      )}
                    </div>

                    <div className="price ms-0 ms-sm-5 ms-md-5">
                      ${duiInformation[0].price}
                    </div>
                  </div>
                  <ul className="list-inline">
                    {!loading &&
                      duiInformation[0].features &&
                      duiInformation[0].features.map((duiData, index) => (
                        <li
                          key={index}
                          className="list-inline-item mb-2 mb-md-3 d-flex align-items-baseline"
                        >
                          <i className="fa-solid fa-circle me-2"></i>
                          {duiData}
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="dui-school section-padding">
        <div className="container">
          <div className="row justify-content-center">
            {duiInformation &&
              !loading &&
              duiInformation.length &&
              duiInformation.map((duiData, dIndex) => {
                return dIndex === 0 ? null : (
                  <DuiProgram key={dIndex} duiData={duiData} slug={slug} />
                );
              })}
          </div>
        </div>
      </section>
      {duiDetail && !loading && <DuiDetails duiDetail={duiDetail} />}
    </>
  );
};

export default LayoutOne;
